import { StatusControl } from "@/components/status/status-control";
import { useSetVideoStatus, useStatusOptions } from "@/hooks/use-status";
import type { Video } from "@/lib/api-types";

type Props = {
  projectId: string;
  video: Video;
};

/**
 * Card Status control — unified extensible Status field (migration 0023),
 * replaces the old fixed 3-tier approval dropdown. Lists workspace options +
 * "Add …" to create; the selected status shows as a colored chip. Any workspace
 * role can change it (reuses CHANGE_APPROVAL_STATUS server-side).
 */
export function VideoStatusControl({ projectId, video }: Props) {
  const { data } = useStatusOptions();
  const setStatus = useSetVideoStatus(projectId);

  return (
    <StatusControl
      options={data?.options ?? []}
      current={video.status ?? null}
      pending={setStatus.isPending}
      onPick={(statusOptionId) => setStatus.mutate({ videoId: video.id, statusOptionId })}
      onCreate={(label) => setStatus.mutate({ videoId: video.id, label })}
    />
  );
}
